// extracted by mini-css-extract-plugin
export default {"centralWrapper":"errorPage_centralWrapper__Wq99n","central":"errorPage_central__Ern-H","content":"errorPage_content__Os5aP","errorCodeBlock":"errorPage_errorCodeBlock__LnbO4"};